// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"253":"0266dda5","290":"7d630689","505":"aff0e256","787":"7401bc82","836":"bf4b1fdf"}[chunkId] + ".chunk.js";
};